import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { techDocsMermaidAddonModule } from 'backstage-plugin-techdocs-addon-mermaid/alpha';
import { authModule } from './modules/auth';
import { i18nModule } from './modules/i18n';
import { navModule } from './modules/nav';
import { themeModule } from './modules/theme';

// Con app.packages: all en app-config.yaml, el resto de plugins
// (scaffolder, api-docs, catalog-import, techdocs, notifications, etc.)
// se descubren solos desde packages/app/package.json.
export default createApp({
  features: [
    catalogPlugin,
    techDocsMermaidAddonModule,
    authModule,
    navModule,
    themeModule,
    i18nModule,
  ],
});
